import { render, staticRenderFns } from "./top5UsualCyclingCard.vue?vue&type=template&id=11841f71&scoped=true&"
import script from "./top5UsualCyclingCard.vue?vue&type=script&lang=js&"
export * from "./top5UsualCyclingCard.vue?vue&type=script&lang=js&"
import style0 from "./top5UsualCyclingCard.vue?vue&type=style&index=0&id=11841f71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11841f71",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VOverlay,VProgressCircular,VRow})
